import { Grid, Paper, Tab, Tabs } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { TabPanel } from "../../../../components/tab-panel";
import { CustomerDetailsTab } from "./municipality-contacts-tab/municipality-contacts-tab";
import { MunicipalityNoteTab } from "./municipality-note-tab/municpality-note-tab.component";

interface DetailsTabComponent {
    municipalityID: number;
    permissionForTab: any;
}
export const DetailsTabComponent = ({ municipalityID, permissionForTab }: DetailsTabComponent) => {
    const [value, setValue] = useState('projects');

    const handleTabsChange = (event: any, value: any) => {
        setValue(value);
    };

    const availableTabs = useMemo(
        () =>
            [
                permissionForTab?.contactTab && 'municipality-contacts',
                permissionForTab?.noteTab && 'notes',
            ].filter(Boolean),
        [permissionForTab]
    );

    useEffect(() => {
        if (!availableTabs.includes(value)) {
            setValue(availableTabs[0] as string);
        }
    }, [availableTabs]);

    if (!municipalityID) {
        return <div>Invalid Municipality</div>;
      }

    return (
        <Paper elevation={0}>
            <Grid item>
                <Tabs value={value} onChange={handleTabsChange}>
                    <Tab value="municipality-contacts" label="Municipality Contacts" hidden={!permissionForTab?.contactTab} />
                    <Tab value="notes" label="Notes" hidden={!permissionForTab?.noteTab} />
                </Tabs>

                {/* Conditionally render TabPanels based on selected tab and permissions */}
                {value === 'municipality-contacts' && permissionForTab?.contactTab && (
                    <TabPanel selectedValue={value} value="municipality-contacts">
                        <CustomerDetailsTab municipalityID={Number(municipalityID)} />
                    </TabPanel>
                )}
                {value === 'notes' && permissionForTab?.noteTab && (
                    <TabPanel selectedValue={value} value="notes">
                        <MunicipalityNoteTab municipalityID={Number(municipalityID)} />
                    </TabPanel>
                )}
            </Grid>
        </Paper>
    );
}